import { render, staticRenderFns } from "./SelectorExams.vue?vue&type=template&id=7c9f1010&"
import script from "./SelectorExams.vue?vue&type=script&lang=js&"
export * from "./SelectorExams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports